/**
 * Framer-motion shell for save-filter modal (overlay + card container).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC, ReactNode } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { Card } from '@/components/ui';

interface SaveFilterModalShellProps {
  onClose: () => void;
  children: ReactNode;
}

export const SaveFilterModalShell: FC<SaveFilterModalShellProps> = ({
  onClose,
  children,
}) => (
  <AnimatePresence>
    <motion.div
      className="fixed inset-0 z-[200]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
      />
      <motion.div
        initial={{ opacity: 0, y: 12, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 12, scale: 0.98 }}
        transition={{ duration: 0.15 }}
        className="absolute inset-0 flex items-center justify-center p-6"
        role="dialog"
        aria-modal="true"
      >
        <Card
          className="w-full max-w-[520px] overflow-hidden shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </Card>
      </motion.div>
    </motion.div>
  </AnimatePresence>
);
